import type { RequestDecision, RequestEnforcement } from '../../api/types';
import { strings } from '../../strings';
import { decisionTone, enforcementTone } from './tones';

const r = strings.networks.requests;

/** A decision as a badge with its icon and word. */
export function DecisionBadge({ decision }: { decision: RequestDecision }) {
  const { tone, icon: Icon } = decisionTone(decision);
  return (
    <span className={`badge tone-${tone}`}>
      <Icon aria-hidden className="size-3.5" />
      {r.decision[decision]}
    </span>
  );
}

/** An instance's state in the Traffic tab's words, as a badge with its icon. */
export function RequestStateBadge({
  state,
  enforcement,
  enforcing,
  decision,
}: {
  state: string;
  enforcement: RequestEnforcement;
  enforcing: boolean;
  decision: RequestDecision | null;
}) {
  const { tone, icon: Icon } = enforcementTone(enforcement, enforcing, decision);
  return (
    <span className={`badge tone-${tone} net-request-state`}>
      <Icon aria-hidden className="size-3.5 shrink-0" />
      {state}
    </span>
  );
}
